import React from "react";

const Loader = () => {
  return (
    <span className="border-4 w-6 h-6 border-dashed rounded-full animate-spin border-white"></span>
  );
};

export default Loader;
